import React from 'react';
import PropTypes from 'prop-types';
import OtherLocationIcon from '../icons/OtherLocationIcon';
import ThisLocationIcon from '../icons/ThisLocationIcon';
import styles from './LocationReturnSwitcher.scss';

function LocationReturnSwitcher({ isSameLocationReturn, onClick, specificLocator }) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={styles.locationReturnSwitcher}
      onClick={onClick}
      data-locator={`return-location-switcher${specificLocator ? '-' + specificLocator : ''}`}
    >
      {isSameLocationReturn ? <ThisLocationIcon /> : <OtherLocationIcon />}
      <span className={styles.locationInnerText}>
        {isSameLocationReturn ? 'Вернуть в том же месте' : 'Вернуть в другом городе'}
      </span>
    </div>
  );
}

LocationReturnSwitcher.propTypes = {
  isSameLocationReturn: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default LocationReturnSwitcher;
